import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useDeleteUserMutation} from '../hooks/useUsersQuery';
import {useUsersSelection} from '../hooks/useUsersSelection';
import {notifyError, notifySuccess} from '../../../components/PlatformNotification';

// Deletes every selected person and reports once. Each delete is settled on its
// own: the console's copy awaited them in a loop, so the first failure stopped
// the rest and left the whole selection in place with no message saying which
// ones had gone. Here the people who were deleted leave the selection, and any
// who were not stay selected for another try.
export const DeleteRecordButton = () => {

    const deleteUserMutation = useDeleteUserMutation();

    const {
        selection,
        handleRowSelection,
    } = useUsersSelection();

    const usernames = Object.keys(selection).filter(id => selection[id] === true);

    const handleDelete = async () => {
        const results = await Promise.allSettled(
            usernames.map(username => deleteUserMutation.mutateAsync(username)));

        const failed: string[] = [];
        results.forEach((result, index) => {
            if (result.status === 'fulfilled') {
                handleRowSelection(usernames[index], false);
            } else {
                failed.push(usernames[index]);
            }
        });

        const deleted = usernames.length - failed.length;
        if (deleted > 0) {
            notifySuccess(deleted === 1 ? 'User deleted' : `${deleted} users deleted`);
        }
        if (failed.length > 0) {
            notifyError(`${failed.length} could not be deleted and are still selected.`);
        }
    };

    return (
        <DeleteRecordsConfirmationButton
            disabled={usernames.length === 0}
            recordIdsLength={usernames.length}
            handleConfirm={handleDelete}
        />
    );
};
